import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';

import './style.css';

class FilterPopover extends Component {
  constructor(props) {
    super(props);
    this.popoverRef = React.createRef();
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);
    // Focus the input after mount
    if (this.inputRef.current) {
      this.inputRef.current.focus();
      // Move cursor to end
      const val = this.inputRef.current.value;
      this.inputRef.current.value = '';
      this.inputRef.current.value = val;
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleClickOutside = (e) => {
    if (this.popoverRef.current && !this.popoverRef.current.contains(e.target)) {
      this.props.onClose();
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.props.onClose();
    } else if (e.key === 'Enter') {
      this.props.onSubmit(e);
    }
  };

  render() {
    const { column, filter, onChange, onSubmit, anchorRect, t } = this.props;

    if (!anchorRect) return null;

    const filterValue = filter ? filter.filter : '';
    const hasValue = filterValue.length > 0;

    // Calculate position - below the filter icon, aligned to the right edge
    const popoverWidth = 240;
    const style = {
      top: anchorRect.bottom + 6,
      left: Math.max(8, anchorRect.right - popoverWidth),
    };

    // Check if popover would go off screen on the right
    if (style.left + popoverWidth > window.innerWidth - 8) {
      style.left = window.innerWidth - popoverWidth - 8;
    }

    return ReactDOM.createPortal(
      <div className="filter-popover-overlay">
        <div
          className="filter-popover"
          ref={this.popoverRef}
          style={style}
        >
          <div className="filter-popover-input-group">
            <input
              ref={this.inputRef}
              type="text"
              className="filter-popover-input"
              placeholder={column.name}
              value={filterValue}
              onChange={(e) => onChange(e, column.index)}
            />
            {hasValue && (
              <button
                type="button"
                className="filter-popover-clear"
                onClick={(e) => onSubmit(e, true)}
                title={t('btn:clear')}
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            )}
          </div>
          <button
            type="button"
            className="filter-popover-apply"
            onClick={onSubmit}
          >
            {t('btn:apply')}
          </button>
        </div>
      </div>,
      document.body
    );
  }
}

export default withTranslation()(FilterPopover);
